import qr from "query-string";
import { useQuery } from "@tanstack/react-query";
import { API, fetcher } from "@/shared/core-configs";
import { BaseEquipmentInstance } from "../types/EquipmentInstance";

const GET_BASE_EQUIPMENT_INSTANCES_FETCH_KEY =
  "@CORE_GET_BASE_EQUIPMENT_INSTANCES_KEY";

interface getBaseEquipmentInstancesProps {
  zoneIds?: string[] | string;
}

export const getBaseEquipmentInstances = async ({
  zoneIds,
}: getBaseEquipmentInstancesProps): Promise<BaseEquipmentInstance[]> => {
  const params = qr.stringify({
    zoneIds,
  });
  const response = await fetcher.get(
    `${API.GESLUB_SERVICE}/base-equipment-instance?${params}`,
  );
  return response.data;
};

export const useGetBaseEquipmentInstances = ({
  zoneIds,
}: getBaseEquipmentInstancesProps) => {
  const { data, isPending, error } = useQuery({
    queryKey: [GET_BASE_EQUIPMENT_INSTANCES_FETCH_KEY, zoneIds],
    queryFn: () => getBaseEquipmentInstances({ zoneIds }),
  });

  return {
    data,
    isPending,
    error,
  };
};
